
import { TokenService } from './../services/token.service';
import { mergeMap } from 'rxjs/operators';
import { AuthService } from './../../auth.service';
import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Observable, pipe, of } from 'rxjs'
import { environment } from '@env/environment';
import { MsalService } from '@azure/msal-angular/dist/msal.service';



// export class TokenRefreshInterceptor implements HttpInterceptor {
//   private OAUTH_SETTINGS = environment.oauth_setting;
  
//   constructor(
//     private TokenService: TokenService,
//     private AuthService: AuthService,
//     private msalService: MsalService
//   ){}

//   intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
//     request = this.addToken(request);
//     return next.handle(request);
//   }

//   private  addToken(request: HttpRequest<any>){
//     const token: any =  this.TokenService.getToken();
//     if (token) {
//       request = request.clone({
//         setHeaders: {
//          // 'Authorization' : 'Bearer ' + token,
//           token,
//         }
//       })
//       return request;
//     }
//     return request;
//   }
// }


// borrar
export class TokenRefreshInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
  }
}
